// extracted by mini-css-extract-plugin
module.exports = {"view":"index_view_kX4sa"};